import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import docReg from "../../images/doctors/docreg.jpg"
import "./form.css";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../../redux/apiCalls/authApiCall";
import swal from "sweetalert";
import { BsEyeFill, BsPersonCircle, BsEyeSlashFill } from "react-icons/bs";
import { MdMarkEmailUnread } from "react-icons/md";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const registerMessage = useSelector((state) => state.auth.registerMessage);
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [visiblePassword, setVisiblePassword] = useState(false);

  const registerSubmitHandler = (e) => {
    e.preventDefault();
    if (username.trim() === "") {
      return toast.error("يجب ادخال الاسم");
    }
    if (email.trim() === "") {
      return toast.error("يجب ادخال الاميل");
    }
    if (password.trim() === "") {
      return toast.error("يجب ادخال كلمة السر");
    }
    dispatch(registerUser({ username, email, password }));
  };
  if (registerMessage) {
    swal({
      title: registerMessage,
      icon: "success",
    }).then((isOk) => {
      //Go to login page
      navigate("/login");
    });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-style">
      <div className="form-wrapper">
        <img src={docReg} alt="doc" />
        <h4 className="form-title">تسجيل</h4>
        <form onSubmit={registerSubmitHandler} className="form">
          <div className="form-input">
            <input
              type="text"
              placeholder="الاسم"
              className="form-input"
              id="username"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
            />
            <BsPersonCircle className="register-icon" />
          </div>
          <div className="form-input">
            <input
              type="email"
              placeholder="الاميل"
              className="form-input"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <MdMarkEmailUnread className="register-icon" />
          </div>

          <div className="form-input">
            <input
              type={visiblePassword ? "text" : "password"}
              placeholder="كلمة السر"
              className="form-input"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div onClick={()=> setVisiblePassword(!visiblePassword)}  className="icons-wrapper-register">
              {visiblePassword ? (
                <BsEyeFill className="register-icon" />
              ) : (
                <BsEyeSlashFill className="register-icon" />
              )}
            </div>
          </div>

          <button type="submit">تسجيل</button>
        </form>
        <div className="form-footer">
          <span> لدى حساب ..</span>
          <Link className="form-footer" to="/login">
            دخول الموقع
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
